import { render, staticRenderFns } from "./activedetail.vue?vue&type=template&id=5b982036&scoped=true"
import script from "./activedetail.vue?vue&type=script&lang=js"
export * from "./activedetail.vue?vue&type=script&lang=js"
import style0 from "./activedetail.vue?vue&type=style&index=0&id=5b982036&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b982036",
  null
  
)

export default component.exports